import { IsEnum, IsNumber, IsString } from 'class-validator';
import { EntityVm } from 'api/core/entity.vm';

export enum AsrsType {
  KARDEX = 'KARDEX',
}

export class ServerVm extends EntityVm {
  @IsEnum(AsrsType)
  type: AsrsType;

  @IsString()
  name: string;

  @IsString()
  host: string;

  @IsNumber()
  port: number;
}
